/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  // googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello.",
  title2: "Manav",
  logo_name: "MJ",
  nickname: "MJ45",
  full_name: "Manav Jethva",
  subTitle:
    "Full Stack Developer, DevOps Enthusiast . Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/1AhnXwiqgrbzerDf-0Y2x3EwhhZN6mD8K/view?usp=sharing",
  mail: "mailto:hrishipatel99@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/ManavJethva",
  linkedin: "https://www.linkedin.com/in/manav-jethva-b94492232/",
  gmail: "manavj4524@gmail.com",
  
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using ReactJS and NextJS",
        "⚡ Backend development using NodeJS, ExpressJS ",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#007ACC",
          },
        },
        
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#000000",
            filter: "invert(1)"
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },

        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#181717",
            filter: "invert(1)"
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FF6C37",
          },
        },
       
        
      ],
    },

    // {
    //   title: "Cloud Infra-Architecture",
    //   fileName: "CloudInfraImg",
    //   skills: [
    //     "⚡ Certified AWS Developer Associate and Cloud Practioner",
    //     "⚡ Experience working on multiple cloud platforms",
    //     "⚡ Experience hosting and managing web apps on GCP and AWS",
    //     "⚡ Deploying deep learning models on cloud to use on mobile devices",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "GCP",
    //       fontAwesomeClassname: "simple-icons:googlecloud",
    //       style: {
    //         color: "#4285F4",
    //       },
    //     },
    //     {
    //       skillName: "AWS",
    //       fontAwesomeClassname: "simple-icons:amazonaws",
    //       style: {
    //         color: "#FF9900",
    //       },
    //     },
    //     {
    //       skillName: "Netlify",
    //       fontAwesomeClassname: "simple-icons:netlify",
    //       style: {
    //         color: "#38AFBB",
    //       },
    //     },
    //     {
    //       skillName: "Heroku",
    //       fontAwesomeClassname: "simple-icons:heroku",
    //       style: {
    //         color: "#6863A6",
    //       },
    //     },
    //     {
    //       skillName: "Firebase",
    //       fontAwesomeClassname: "simple-icons:firebase",
    //       style: {
    //         color: "#FFCA28",
    //       },
    //     },
    //     {
    //       skillName: "MongoDB",
    //       fontAwesomeClassname: "simple-icons:mongodb",
    //       style: {
    //         color: "#47A248",
    //       },
    //     },
    //     {
    //       skillName: "Docker",
    //       fontAwesomeClassname: "simple-icons:docker",
    //       style: {
    //         color: "#1488C6",
    //       },
    //     },
    //   ],
    // },
    {
      title: "Additional proficiencies",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Experience in building some Python Projects",
        "⚡Experience in Linux systems like ubuntu",
    
      ],
      "softwareSkills": [
        {
          "skillName": "Python",
          "fontAwesomeClassname": "simple-icons:python",
          "style": {
            "backgroundColor": "transparent",
            "color": "#3776AB"
          }
        },
        {
          skillName: "C",
          fontAwesomeClassname: "logos:c",
          style: {
            color: "#A8B9CC",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "logos:c-plusplus",
          style: {
            color: "#00599C",
          },
        },
        {
          "skillName": "Jupyter Notebook",
          "fontAwesomeClassname": "simple-icons:jupyter",
          "style": {
            "backgroundColor": "transparent",
            "color": "#F37726"
          }
        },
        {
          "skillName": "Linux",
          "fontAwesomeClassname": "simple-icons:linux",
          "style": {
            "backgroundColor": "transparent",
            "color": "#000000"
          }
        },
        {
          "skillName": "Ubuntu",
          "fontAwesomeClassname": "simple-icons:ubuntu",
          "style": {
            "backgroundColor": "transparent",
            "color": "#E95420"
          }
        }
      ]
      
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Atal Bihari Vajpayee Indian Institute of Information Technology and Mangement",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "ABV_Logo.jpg",
      alt_name: "SETI",
      duration: "2021 - 2025",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have implemented several projects based on what I've learnt under my Computer Engineering course. ",
      ],
      website_link: "https://www.iiitm.ac.in/",
    },
    {
      title: "Vidyaniketan College of Science",
      subtitle: "Class XII H.S.C Board",
      logo_path: "vidya_Logo (1).png",
      alt_name: "SETI",
      duration: "2019 - 2021",
      descriptions: [
        "⚡I completed my Class 12th in Maharashtra Board with 93%",
      ],
      website_link: "https://schools.org.in/mumbai-ii/27230300482/vidya-niketan-jr-college-of-commerce-and-sicence-ghtkopar-e.html",
    },
    {
      title: "Ryan International School Chembur",
      subtitle: "Class 10th  I.C.S.E Board",
      logo_path: "Ryan_Logo.png",
      alt_name: "SETI",
      duration: "2019 - 2021",
      descriptions: [
        "⚡I completed my Class 10th in I.C.S.E board with 91%",
      ],
      website_link: "https://schools.org.in/mumbai-ii/27230300482/vidya-niketan-jr-college-of-commerce-and-sicence-ghtkopar-e.html",
    },
  ],
};

 const certifications = {
//   certifications: [
//     {
//       title: "AWS Developer Associate",
//       subtitle: "Amazon Web Services",
//       logo_path: "aws.png",
//       certificate_link:
//         "https://www.credly.com/badges/b12fbece-07f3-47f5-9dda-cd56f49e250d/public_url",
//       alt_name: "AWS",
//       color_code: "#ffc475",
//     },
//     {
//       title: "AWS Certified Cloud Practioner",
//       subtitle: "Amazon Web Services",
//       logo_path: "aws.png",
//       certificate_link:
//         "https://www.credly.com/badges/8b2db191-702d-427c-91aa-0f926be447a6/public_url",
//       alt_name: "AWS",
//       color_code: "#ffc475",
//     },
//     {
//       title: "Google Summer of Code 2019",
//       subtitle: "Google / Sugar Labs",
//       logo_path: "google_logo.png",
//       certificate_link: " ",
//       alt_name: "Google",
//       color_code: "#ffc475",
//     },
//     {
//       title: "Google Code-In Student",
//       subtitle: "2014-2017",
//       logo_path: "google_logo.png",
//       certificate_link: " ",
//       alt_name: "Google",
//       color_code: "#1e70c1",
//     },
//     {
//       title: "Google Summer of Code Mentor",
//       subtitle: "2017 / 2018 / 2020",
//       logo_path: "google_logo.png",
//       certificate_link: " ",
//       alt_name: "Google",
//       color_code: "#ffbfae",
//     },
//     {
//       title: "Google Code-In Mentor",
//       subtitle: "2017 / 2018 / 2019",
//       logo_path: "google_logo.png",
//       certificate_link: " ",
//       alt_name: "Google",
//       color_code: "#b190b0",
//     },
//     {
//       title: "Deep Learning Specialization",
//       subtitle: "deeplearning.ai",
//       logo_path: "deeplearning_ai_logo.png",
//       certificate_link:
//         "https://coursera.org/share/737a9587023c666b8e6cb303157aaeba",
//       alt_name: "deeplearning.ai",
//       color_code: "#47A048",
//     },
//     {
//       title: "Sequence Models",
//       subtitle: "deeplearning.ai",
//       logo_path: "deeplearning_ai_logo.png",
//       certificate_link:
//         "https://www.coursera.org/account/accomplishments/verify/FM5AKEZA9NUY",
//       alt_name: "deeplearning.ai",
//       color_code: "#F6B808",
//     },
//     {
//       title: "Convolutional Neural Networks",
//       subtitle: "deeplearning.ai",
//       logo_path: "deeplearning_ai_logo.png",
//       certificate_link:
//         "https://www.coursera.org/account/accomplishments/verify/U8BLDNUT9UUM",
//       alt_name: "deeplearning.ai",
//       color_code: "#2AAFED",
//     },
//     {
//       title: "Structuring Machine Learning Projects",
//       subtitle: "deeplearning.ai",
//       logo_path: "deeplearning_ai_logo.png",
//       certificate_link:
//         "https://www.coursera.org/account/accomplishments/verify/YLC25SJQKH3Y",
//       alt_name: "deeplearning.ai",
//       color_code: "#E2405F",
//     },
//     {
//       title: "Machine Learning",
//       subtitle: "deeplearning.ai",
//       logo_path: "stanford_logo.png",
//       certificate_link:
//         "https://www.coursera.org/account/accomplishments/records/72KY93DT82MP",
//       alt_name: "Stanford University",
//       color_code: "#8C151599",
//     },
//     {
//       title: "Neural Networks and Deep Learning",
//       subtitle: "deeplearning.ai",
//       logo_path: "deeplearning_ai_logo.png",
//       certificate_link:
//         "https://www.coursera.org/account/accomplishments/records/25JXRB2RWHRX",
//       alt_name: "Google",
//       color_code: "#7A7A7A",
//     },
//     {
//       title: "Improving Deep Neural Networks",
//       subtitle: "deeplearning.ai",
//       logo_path: "deeplearning_ai_logo.png",
//       certificate_link:
//         "https://www.coursera.org/account/accomplishments/records/PKR9M9LQ3JWC",
//       alt_name: "Google",
//       color_code: "#0C9D5899",
//     },
//     {
//       title: "Android Developer Nanodegree",
//       subtitle: "Part of Google India Scholarship Program",
//       logo_path: "100.png",
//       certificate_link: "https://graduation.udacity.com/confirm/HLE7K5V3",
//       alt_name: "Google",
//       color_code: "#C5E2EE",
//     },
//     {
//       title: "InOut 4.0 Winner #2",
//       subtitle: "2017",
//       logo_path: "ino.png",
//       certificate_link: " ",
//       alt_name: "InOut",
//       color_code: "#fffbf3",
//     },
//   ],
 };

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've completed two internships. I've mostly done projects on my own and I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "IT Developer",
          company: "Canada Revenue Agency",
          company_url: "https://www.canada.ca/en/revenue-agency.html",
          logo_path: "cra.png",
          duration: "May 2023 - Ongoing",
          location: "Halifax, Nova Scotia",
          description:
            "Canada Revenue Agency (CRA) administers tax laws for the Government of Canada and for most provinces and territories, and administers various social and economic benefit and incentive programs delivered through the tax system.",
          color: "#f10000",
        },
        {
          title: "Full Stack Developer",
          company: "Quicko",
          company_url: "https://quicko.com/",
          logo_path: "quicko.jpg",
          duration: "June 2021 - October 2021",
          location: "Ahmedabad",
          description:
            "Quicko is an online tax planning, preparation & filing platform for individuals & businesses.",
          color: "#2962FF",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Google Summer of Code",
          company: "Sugar Labs",
          company_url: "https://sugarlabs.org/",
          logo_path: "google_logo.png",
          duration: "May 2019 - Aug 2019",
          location: "Work From Home",
          description:
            "I worked on the Dashboard project which helps users track their activities while using Sugar OS. I also worked on making a Tamagotchi-like widget for Sugar's Home Screen",
          color: "#ee3c26",
        },
        {
          title: "Android App Developer Intern",
          company: "IAS4Sure",
          company_url: " ",
          logo_path: "buld.jpg",
          duration: "December 2019 - February 2020",
          location: "Work From Home",
          description:
            "Internship task was to make a native Android application. ",
          color: "#0071C5",
        },
        {
          title: "Web Developer",
          company: "Wrighter Writing Solutions",
          company_url: " ",
          logo_path: "wrighter.jpg",
          duration: "August 2020",
          location: "",
          description: "Develop a website using PHP and jQuery.",
          color: "#56A4D3",
        },
        {
          title: "Front-End Developer",
          company: "VJ TechServe",
          company_url: " ",
          logo_path: "vjt.png",
          duration: "September 2020",
          location: "",
          description: "Develop a portfolio website using ReactJS",
          color: "#800000",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Google Summer of Code Mentor",
          company: "Sugar Labs / GSoC",
          company_url: "https://sugarlabs.org/",
          logo_path: "google_logo.png",
          duration: "Summer of 2017 / 18 / 20",
          location: " ",
          description:
            "Mentorship responsibilities were to help students plan the project, review issues and pull requests, ensure smooth progress and help them out when they are stuck.",
          color: "#4285F4",
        },
        {
          title: "Google Code-In Mentor",
          company: "Sugar Labs / GSoC",
          company_url: "https://sugarlabs.org/",
          logo_path: "google_logo.png",
          duration: "Winter of 2017 / 18 / 19",
          location: " ",
          description:
            "Day to day resposibilites of this mentorship was to help out children aged 13-17 get started with programming and open-source, review their work and approve them.",
          color: "#D83B01",
        },
        {
          title: "Board Member at Codeuino",
          company: " ",
          company_url: " ",
          logo_path: "codeuino.jpg",
          duration: "2018 - 2019",
          location: " ",
          description: "Previous Board during early days of Codeuino",
          color: "#D83B01",
        },
        {
          title: "BluWings Club",
          company: " ",
          company_url: " ",
          logo_path: "b.png",
          duration: "2018 - On Going",
          location: " ",
          description:
            "Co-Founder and President of the programming club called BluWings. Have organized several workshops which introduced programming and related tools to freshers.",
          color: "#D83B01",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Mern Stack Projects. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Profile.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try my best to write a blog about it.",
    link: "https://medium.com/@hrishipatel99",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "SecurX",
      url: "https://securex-ultimate-password-manager.netlify.app/",
      description:
        "Store your passwords in a secure, private storage facility that you can access with just one click from any of your devices.",
        image:"Securex.png",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "Node",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Express",
          iconifyClass: "logos-express",
        },

      ],
    },
    {
      name: "Elixir",
      url: "",
      description:
        "Elixir is a powerful tool designed to help educational institutions manage the health records employees, and residents.",
        image:"Elixir.png",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos-mongodb",
        },
        {
          name: "Node",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "Express",
          iconifyClass: "logos-express",
        },
        {
          name: "Redis",
          iconifyClass: "logos-redis",
        },
      

      ],
    },
    {
      name: "MJ's Portfolio",
      url: "",
      description:
        "A personal portfolio made using React, showcasing various animations and frontend techniques.",
        image:"Portfolio.png",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "CSS",
          iconifyClass: "simple-icons:css3",
        },

      ],
    },
    {
      name: "Exam Scheduler",
      url: "",
      description:
        "An Exam Scheduler built using Genetic Algorithms for optimized Schedule Generation .",
        image:"Scheduler.png",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Jupyter Notebook",
          iconifyClass: "simple-icons:jupyter",
        },

      ],
    },
    
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
